<template>
      <div style="overflow:hidden">
          <div style="position:fixed;right:200px;z-index:1;" v-if="roleList['3_11-5']&&roleList['3_11-6']">
              <p style="display:inline-block;margin-top:5px;marin-right:15px;padding-right:10px;letter-spacing:2px;font-size:12px">黑白名单设置:</p>
              <el-radio-group v-model="radio" @change="enabledisable">
               <Tooltip class="tips_font" placement="bottom">
                              <div slot="content">
                                <p>{{setsatadius}}</p>
                                <p>点击禁用黑白名单</p>
                              </div>
                             <el-radio :label="0" >禁用</el-radio>
              </Tooltip>
              <Tooltip class="tips_font" placement="bottom">
                              <div slot="content">
                                <p>{{setsatadius}}</p>
                                <p>点击启用黑名单</p>
                              </div>
                            <el-radio :label="1" >黑名单</el-radio>
              </Tooltip>
              <Tooltip class="tips_font" placement="bottom">
                              <div slot="content">
                                <p>{{setsatadius}}</p>
                                <p>点击启用白名单</p>
                              </div>
                            <el-radio :label="2" >白名单</el-radio>
              </Tooltip>
              </el-radio-group>
          </div>
          <div class="fixed_operation_btn" style="position:fixed;right:100px;z-index:100;">
                  <Tooltip class="tips_font" placement="bottom">
                              <div slot="content">
                                <p>黑名单：无法接通黑名单页面规则匹配的号码（仅针对手动呼出和自动呼出）</p>
                                <p>白名单：只能接通白名单页面规则匹配的号码（仅针对手动呼出和自动呼出）</p>
                              </div>
                            <img src="../../assets/image/homeAsk.png"/>
                  </Tooltip>
          </div>
        <Tabs value="tabblack" @on-click="changeTab">
            <TabPane label="黑名单" name="tabblack">
              <div class="fixed_search" >
                <div class="fixed_search_input" style="width:100px;margin-right:30px">
                  <Select v-model="rostercalltype" >
                    <Option v-for="(option, index) in rostercalltypeList" :value="option.id" :key="index">{{option.name}}</Option>
                  </Select>
                </div>
                <div class="fixed_search_input">
                  <Input v-model="inqnumber"  placeholder="请输入号码" title="查询号码"  clearable/>
                </div>
                <div class="fixed_search_input">
                  <Select v-model="matchtype" placeholder="请选择匹配方式" title="匹配方式" clearable>
                    <Option v-for="(option, index) in matchtypeList" :value="option.id" :key="index">{{option.name}}</Option>
                  </Select>
                </div>
                <div class="fixed_operation_btn">
                  <Button type="primary" @click="initSearch">查询</Button>
                  <Button type="primary" class="operation_btn reset_btn" @click="reset">重置</Button>
                </div>
              </div>
              <div class="public_btn">
                <Button  class="search_btn template_btn"   v-if="roleList['3_11-1']" @click="addroster">添加</Button>
                <Button  class="search_btn template_btn" v-if="roleList['3_11-2']" @click="importlist">导入</Button>
                <Button  class="search_btn template_btn" v-if="roleList['3_11-3']" @click="exportlist">导出</Button>
                <Button  class="search_btn template_btn" v-if="roleList['3_11-4']" @click="batchdeletion">批量删除</Button>
              </div>
              <div class="fixed_table">
                <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
                <el-table :data="contentList" style="width: 100%" :height="tableHeight" class="element_table" :class="{'tableClass':tableClass}" stripe  ref="selection"  @selection-change="getSelectedId">
                  <el-table-column v-for="(item,index) in fieldList" align="center" :show-overflow-tooltip='true' :type="item.type" :key="index"  :prop="item.key" :label="item.title" :width="item.width"></el-table-column>
                  <el-table-column  fixed="right" label="操作"   align="center">
                    <template slot-scope="scope">
                      <el-button v-if="roleList['3_11-7']" @click="editroster(scope.row.id,scope.row.telphone,scope.row.matchOp)"  type="text" size="small">编辑</el-button>
                      <el-button v-if="roleList['3_11-8']" @click="deleteroster(scope.row.id)" type="text" size="small">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
            </div>

            </TabPane>
            <TabPane label="白名单" name="tabwhite">
              <div class="fixed_search">
                <div class="fixed_search_input" style="width:100px;margin-right:30px">
                  <Select v-model="rostercalltype1w" >
                    <Option v-for="(option, index) in rostercalltypeList" :value="option.id" :key="index">{{option.name}}</Option>
                  </Select>
                </div>
                <div class="fixed_search_input">
                  <Input  v-model="inqnumber1w" placeholder="请输入号码" title="号码"  clearable/>
                </div>
                <div class="fixed_search_input">
                  <Select v-model="matchtype1w" placeholder="请选择匹配方式" title="匹配方式" clearable>
                    <Option v-for="(option, index) in matchtypeList" :value="option.id" :key="index">{{option.name}}</Option>
                  </Select>
                </div>
                <div class="fixed_operation_btn">
                  <Button type="primary" @click="initSearch">查询</Button>
                  <Button type="primary" class="operation_btn reset_btn" @click="reset">重置</Button>
                </div>
              </div>
              <div class="public_btn">
                <Button  class="search_btn template_btn"   v-if="roleList['3_11-1']" @click="addroster">添加</Button>
                <Button  class="search_btn template_btn" v-if="roleList['3_11-2']" @click="importlist">导入</Button>
                <Button  class="search_btn template_btn" v-if="roleList['3_11-3']" @click="exportlist">导出</Button>
                <Button  class="search_btn template_btn" v-if="roleList['3_11-4']" @click="batchdeletion">批量删除</Button>
              </div>
              <div class="fixed_table">
                <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
                <el-table :data="contentList" style="width: 100%" :height="tableHeight" class="element_table" :class="{'tableClass':tableClass}" stripe  ref="selection"  @selection-change="getSelectedId">
                  <el-table-column v-for="(item,index) in fieldList" align="center" :show-overflow-tooltip='true' :type="item.type" :key="index"  :prop="item.key" :label="item.title" :width="item.width"></el-table-column>
                  <el-table-column  fixed="right" label="操作"   align="center">
                    <template slot-scope="scope">
                      <el-button v-if="roleList['3_11-7']" @click="editroster(scope.row.id,scope.row.telphone,scope.row.matchOp)"  type="text" size="small">编辑</el-button>
                      <el-button v-if="roleList['3_11-8']" @click="deleteroster(scope.row.id)" type="text" size="small">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </TabPane>
        </Tabs>
        <div class="page_style">
          <Page :total="total" size="small" :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
          <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px;">页</div>
        </div>
        <NameListPop :showNameList="showNameList" :callId="callId" :callmatype="callmatype" :calltel="calltel" :tabslisttype="tabslisttype" :dpid="dpid"  @closeNameListPop="closeNameListPop" ></NameListPop>
        <BatchdeletionRosterPop  @closedeletionPop="closedeletionPop" :tabslisttype="tabslisttype" :showdeletionPop="showdeletionPop" :dpid="dpid"></BatchdeletionRosterPop>
        <RosterImportPop @closeRosterImport="closeRosterImport" :tabslisttype="tabslisttype" :showRosterImport="showRosterImport"></RosterImportPop>
        <RosterExportPop @closeRosterExport="closeRosterExport" :showRosterExport="showRosterExport" :tabslisttype="tabslisttype" :dpid="dpid"></RosterExportPop>

      </div>

</template>
<script>
import {publicFunClass} from '@/components/js/PublicFunClass.js'
import {customerPublicBtn} from '@/components/js/CustomerPublicBtn.js'
import NameListPop from '@/components/systemSetup/NameListPop.vue'
import BatchdeletionRosterPop from '@/components/systemSetup/BatchdeletionRosterPop.vue'
import RosterImportPop from '@/components/systemSetup/RosterImportPop.vue'
import RosterExportPop from '@/components/systemSetup/RosterExportPop.vue'
export default {
    name: "BandWlist",
     mixins:[publicFunClass,customerPublicBtn],
    components:{
      NameListPop,//添加编辑弹屏
      BatchdeletionRosterPop,//批量删除弹屏
      RosterImportPop,//导入弹屏
      RosterExportPop,//导出
    },
    props:{
      pageCode:String
    },
    data(){
      return{
        showPageCount:0,
        spinShow:false,
        tabslistName:'',
        rostercalltypeList:[{'id':'1','name':'呼出'}],
        rostercalltype:"1",
        rostercalltype1w:"1",
        inqnumber:"",
        inqnumber1w:"",
        matchtype:"",
        matchtype1w:"",
        matchtypeList:[{'id':'1','name':'后缀匹配'},{'id':'0','name':'精确匹配'}],
        tableHeight:600,
        tableClass: true,
        contentList: [],
        fieldList: [
          {type: 'selection', width: 50},
          {key:'telphone','title':'号码'},
          {key:'matchOpStr','title':'匹配方式'}
        ],
        roleList: JSON.parse(localStorage.getItem("roleList")),
        total: 0,
        currentPage: 1,
        pageSize: 20,
        pageSizeList: [10, 20, 30, 40, 50, 100, 200],
        speedChangePage: 1,
        showNameList:false,
        callId:'',
        tabslisttype:'',
        showdeletionPop: false,
        showRosterImport:false,
        showRosterExport:false,
        dpid:'',//黑或白名单id
        // status:"",
        checkIds:[],
        callmatype:'',
        calltel:'',
        radio:'',//0:关闭 1:黑名单启用了 2白名单启用了
        setsatadius:"",
        queryParam: null,
      }
    },
    methods:{
          changeTab:function(name){
            if(name=="tabblack"){//黑名单
              this.tabslistName="1";
            }
            if(name=="tabwhite"){//白名单
              this.tabslistName="2";
            }
            this.initSearch();
          },

          //查询
          initSearch:function () {
            let that=this;
            let param={};
            if(this.tabslistName=="1"){//当为黑名单时
              param={
                journalType:"null",
                menuId:"null",
                pageNum:this.currentPage,
                pageSize:this.pageSize,
                callType:this.rostercalltype,//呼出
                telphone:this.inqnumber,//查询输入号码
                matchOp:this.matchtype,//匹配方式
                blackWhiteType:this.tabslistName,
              };
            }
            if(this.tabslistName=="2"){//当为白名单时
              param={
               journalType:"null",
                menuId:"null",
                pageNum:this.currentPage,
                pageSize:this.pageSize,
                callType:this.rostercalltype1w,//呼出
                telphone:this.inqnumber1w,//查询输入号码
                matchOp:this.matchtype1w,//匹配方式
                blackWhiteType:this.tabslistName,
              };
            }
            this.spinShow=true;
            this.queryParam = param;

            this.$http.post("blackWhiteList/toIndex.json",param) .then(function (res) {
              let result=res.data.flag;
              that.spinShow=false;
              if(result!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }
              that.checkIds=[];
              that.contentList=res.data.obj.list.content;
              that.total=res.data.obj.list.totalSize;
              that.dpid=res.data.obj.dpid;//黑或白名单
              that.radio=res.data.obj.status;//0:关闭 1：黑名单 2：白名单
              if(that.radio=="0"){
                that.setsatadius="当前状态为'禁用'";
              }
              if(that.radio=="1"){
                that.setsatadius="当前状态为'黑名单'";
              }
              if(that.radio=="2"){
                that.setsatadius="当前状态为'白名单'";
              }
            });
          },
          //重置
          reset:function(){
              if(this.tabslistName=="1"){
                this.inqnumber="";
                this.matchtype="";
              }
              if(this.tabslistName=="2"){
                this.inqnumber1w="";
                this.matchtype1w="";
              }
          },
          //添加名单
          addroster:function () {
           // this.dpid=this.dpid+'';
            if(this.tabslistName=="1"){
               this.tabslisttype="1";
            }
            if(this.tabslistName=="2"){
              this.tabslisttype="2";
            }
            this.callId='';
            this.calltel='';
            this.callmatype='';
            this.showNameList=true;

          },
          //关闭添加编辑的
          closeNameListPop:function(flag){
            this.showNameList=false;
            if(flag){
              this.initSearch();
            }
          },
          //编辑名单
          editroster:function (id,tel,matype) {

           // this.dpid=this.dpid+'';
            if(this.tabslistName=="1"){
              this.tabslisttype="1";
            }
            if(this.tabslistName=="2"){
              this.tabslisttype="2";
            }
            this.callId=id+'';
            this.calltel=tel;
            this.callmatype=matype;
            this.showNameList=true;
          },
          //删除
          deleteroster:function (id) {
            let that=this;
            let param={
                journalType:"系统管理=>黑白名单=>删除",
                menuId:"3_11-8",
                type:"0",//单条删除type为0选中
                ids:id,
              };
            this.$Modal.confirm({
              title: '提示',
              content: "是否确定删除",
              onOk: () => {
                that.$http.post("blackWhiteList/doDeletes.json",param) .then(function (res) {
                  let result=res.data.flag;
                  if(result!="666"){
                    that.$alert(res.data.msg, '提示', {
                      confirmButtonText: '确定'
                    });
                    return false;
                  }
                  that.$Message.info("删除成功");
                  that.initSearch();
                });
              }
            });
          },
          //批量删除
          batchdeletion:function () {
            if(this.tabslistName=="1"){
              this.tabslisttype="1";
            }
            if(this.tabslistName=="2"){
              this.tabslisttype="2";
            }
            this.showdeletionPop=true;
          },
          //关闭批量删除后
          closedeletionPop:function(flag,deleteStyle,deletedpid,delettabstype){//后两个参数为: 选择按结果0/按搜索1    黑名单1/白名单2
            this.showdeletionPop=false;
            if (flag) {
              let param=[];
              if (deleteStyle=='0'){//选中结果删除
                if (this.checkIds.length==0){
                  this.$Modal.info({
                    title:'提示',
                    content:"当前无可删除的数据"
                  });
                  return false;
                }
                 param={
                  type:deleteStyle,//1搜索 0选中
                  ids:this.checkIds.toString(),
                  journalType:"系统管理=>黑白名单=>批量删除",
                  menuId:"3_11-4",

                };
              }
              if (deleteStyle=='1'){//搜索结果删除
                if(this.contentList.length==0){
                  this.$Modal.info({
                    title:'提示',
                    content:"当前无可删除的数据"
                  });
                  return false;
                }
                if(!this.queryParam){
                    this.$Modal.info({
                      title:'提示',
                      content:"请点击查询后再删除"
                    });
                    return false;
                }
                delete this.queryParam["pageNum"];
                  delete this.queryParam["pageSize"];

                  this.$set(this.queryParam, 'type', deleteStyle);
                  this.$set(this.queryParam, 'journalType', "系统管理=>黑白名单=>批量删除");
                  this.$set(this.queryParam, 'menuId', '3_11-4');
                  this.$set(this.queryParam, 'callType', '2');
                  this.$set(this.queryParam, 'matchOp', this.delematchOp);
                  param = this.queryParam;
              }
              let that=this;
              that.$Modal.confirm({
                    title: '提示',
                    content: "是否确定删除",
                    onOk: () => {
                      that.$http.post("blackWhiteList/doDeletes.json",param) .then(function (res) {
                        let result = res.data.flag;
                        if(result!="666"){
                          that.$alert(res.data.msg, '提示', {
                            confirmButtonText: '确定'
                          });
                          return false;
                        }
                        that.$Message.info("删除成功");
                        that.initSearch();
                      });
                    }
              });
            }
          },
          //导入
          importlist:function(){
            if(this.tabslistName=="1"){
              this.tabslisttype="1";
            }
            if(this.tabslistName=="2"){
              this.tabslisttype="2";
            }
            this.showRosterImport=true
          },
           //导入回调函数
          closeRosterImport:function(flag){
            this.showRosterImport=false
            if(flag){
              this.initSearch();
            }
          },
          //导出
          exportlist:function(){
            if(this.tabslistName=="1"){
              this.tabslisttype="1";
            }
            if(this.tabslistName=="2"){
              this.tabslisttype="2";
            }
            this.showRosterExport=true
          },
          //导出关闭
          closeRosterExport:function (flag,operateStyle,exportdpid,exporttabstype) {
              this.showRosterExport=false;
              if (flag) {
                let transTelephone;
                let transMatchOp;
                let exportType = "";
                if(exporttabstype=='1'){
                  transTelephone=this.inqnumber;
                  transMatchOp= this.matchtype;
                  exportType = "黑名单数据";
                }else if(exporttabstype=='2'){
                  transTelephone=this.inqnumber1w;
                  transMatchOp= this.matchtype1w;
                  exportType = "白名单数据";
                }
                if (operateStyle=='0'){//选中结果
                  if (this.checkIds.length==0){
                    this.$Modal.info({
                      title:'提示',
                      content:"请选择要导出的数据"
                    });
                    return false;
                  }
                  let param={
                    ids:this.checkIds.toString(),
                    type:operateStyle,
                    blackWhiteType:exporttabstype,
                    journalType:"系统管理=>黑白名单=>按选中结果导出"+exportType,
                    menuId:"3_11-3"
                  };
                  let url="blackWhiteList/exportWhiteBlackList.json";
                  this.$Loading.start();
                  this.operateExcelExport(param,url)
                }
                if (operateStyle=='1'){//按搜索结果
                  if(this.contentList.length==0){
                    this.$Modal.info({
                      title:'提示',
                      content:"当前无可导出的数据"
                    });
                    return false;
                  }
                  if(!this.queryParam){
                    this.$Modal.info({
                      title:'提示',
                      content:"请点击查询后再导出"
                    });
                    return false;
                  }

                  delete this.queryParam["pageNum"];
                  delete this.queryParam["pageSize"];

                  this.$set(this.queryParam, 'type', operateStyle);
                  this.$set(this.queryParam, 'journalType', "系统管理=>黑白名单=>按搜索结果导出"+exportType);
                  this.$set(this.queryParam, 'menuId', '3_11-3');
                  this.$set(this.queryParam, 'callType', '2');
                  this.$set(this.queryParam, 'dpid', exportdpid);
                  this.$set(this.queryParam, 'blackWhiteType', exporttabstype);

                  let url="blackWhiteList/exportWhiteBlackList.json";
                  this.$Loading.start();
                  this.operateExcelExport(this.queryParam,url)
                }
              }
            },
          //禁用启用
         enabledisable:function(event){
            let that=this;
            let journalType = "禁用黑白名单";
            let menuId = "3_11-6";
            if("1" == event){
              journalType = "启用黑名单";
              menuId = "3_11-5";
            }else if("2" == event){
              journalType = "启用白名单";
              menuId = "3_11-5";
            }
            let param={
              status:event,
              journalType: journalType,
              menuId:menuId,
            };
            that.$Modal.confirm({
                    title: '提示',
                    content: "是否确定更改",
                    onOk: () => {
                      that.$http.post("blackWhiteList/doAction.json",param) .then(function (res) {
                        let result = res.data.flag;
                        if(result!="666"){
                          that.$alert(res.data.msg, '提示', {
                            confirmButtonText: '确定'
                          });
                          return false;
                        }
                        that.$Message.info("更改成功");
                        that.initSearch();
                      });
                    },
                    onCancel: () => {
                       that.initSearch();
                    },
          });

         },

    },
    created(){
      let clientHeight=document.documentElement.clientHeight;
      this.tableHeight=clientHeight-287;
      this.tabslistName="1";
    },
    watch:{
      pageCode:function () {
        if(this.pageCode=='3_11' && this.showPageCount==0){
          this.showPageCount++;
          this.initSearch();
        }
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/systemSetup/BandWlist.vue